export const CORE_MODELS = [
  "equal-groups",
  "part-whole",
  "comparison",
  "unitary",
  "packed-quantities",
  "before-after",
  "remainder-constraint",
] as const;

export type CoreModel = (typeof CORE_MODELS)[number];
export type ProblemModel = CoreModel | "mixed-heuristic";
export type ErrorCategory = "relationship" | "operation" | "calculation" | "unit";

export const MODEL_LABELS: Record<ProblemModel, string> = {
  "equal-groups": "Equal Groups & Sharing",
  "part-whole": "Part–Whole",
  comparison: "Comparison",
  unitary: "Unitary Method",
  "packed-quantities": "Packed Quantities",
  "before-after": "Before & After",
  "remainder-constraint": "Remainder Constraints",
  "mixed-heuristic": "Mixed Transfer",
};

export interface GeneratedQuestion {
  templateId: string;
  model: ProblemModel;
  difficulty: 1 | 2 | 3;
  prompt: string;
  expectedAnswer: number;
  expectedUnit: string;
  acceptedPaths: string[][];
  canonicalSolution: string[];
  hint: string;
}

export interface QuestionTemplate {
  id: string;
  model: ProblemModel;
  baseDifficulty: 1 | 2 | 3;
  generate(seed: string, difficulty?: 1 | 2 | 3): GeneratedQuestion;
}

export interface PublicProblem {
  id: string;
  position: number;
  model: ProblemModel;
  prompt: string;
  status: "open" | "deferred" | "solved";
  attemptCount: number;
  assisted: boolean;
  draft?: WorkedAnswerDraft;
}

export interface WorkedAnswerDraft {
  equations: string[];
  finalAnswer: string;
  unit: string;
}

export interface AttemptFeedback {
  correct: boolean;
  assisted: boolean;
  errorCategory?: ErrorCategory;
  message: string;
  hint?: string;
  solution?: string[];
  practiceCompleted?: boolean;
  badgeId?: string;
}

